import React, { Children } from "react"
import { GlobalReducer } from "./GlobalReducer"

export const intialValue = {
    organization: {},
    user:{},
    subscription: {},
    organizations: []
}

export const GlobalContext = React.createContext(intialValue)

export const GlobalContextProvider = ({ children, value = {} }) => {

    const [state, dispatch] = React.useReducer(GlobalReducer, { ...intialValue, ...value })

    return (
        <GlobalContext.Provider value={{
            state,
            dispatch
        }}>
            {children}
        </GlobalContext.Provider>
    )
}

export const useGlobalContext = () => {
    const context = React.useContext(GlobalContext)
    if (!context) {
        throw new Error("useGlobal must be used within a GlobalContextProvider")
    }
    return context
}